<script>
    import VueContentLoading from 'vue-content-loading';

    export default {
        components: {
            VueContentLoading,
        },
    };
</script>

<template>
    <vue-content-loading :width="300" :height="70">
        <rect x="2" y="2" rx="1" ry="1" width="45" height="3" />
        <rect x="55" y="2" rx="1" ry="1" width="80" height="3" />
        <rect x="145" y="2" rx="1" ry="1" width="30" height="3" />
        <rect x="185" y="2" rx="1" ry="1" width="75" height="3" />
        <rect x="270" y="2" rx="1" ry="1" width="20" height="3" />

        <rect x="2" y="9" rx="1" ry="1" width="45" height="3" />
        <rect x="55" y="9" rx="1" ry="1" width="80" height="3" />
        <rect x="145" y="9" rx="1" ry="1" width="30" height="3" />
        <rect x="185" y="9" rx="1" ry="1" width="75" height="3" />
        <rect x="270" y="9" rx="1" ry="1" width="20" height="3" />

        <rect x="2" y="16" rx="1" ry="1" width="45" height="3" />
        <rect x="55" y="16" rx="1" ry="1" width="80" height="3" />
        <rect x="145" y="16" rx="1" ry="1" width="30" height="3" />
        <rect x="185" y="16" rx="1" ry="1" width="75" height="3" />
        <rect x="270" y="16" rx="1" ry="1" width="20" height="3" />

        <rect x="2" y="22" rx="1" ry="1" width="45" height="3" />
        <rect x="55" y="22" rx="1" ry="1" width="80" height="3" />
        <rect x="145" y="22" rx="1" ry="1" width="30" height="3" />
        <rect x="185" y="22" rx="1" ry="1" width="75" height="3" />
        <rect x="270" y="22" rx="1" ry="1" width="20" height="3" />

        <rect x="2" y="29" rx="1" ry="1" width="45" height="3" />
        <rect x="55" y="29" rx="1" ry="1" width="80" height="3" />
        <rect x="145" y="29" rx="1" ry="1" width="30" height="3" />
        <rect x="185" y="29" rx="1" ry="1" width="75" height="3" />
        <rect x="270" y="29" rx="1" ry="1" width="20" height="3" />

        <rect x="2" y="36" rx="1" ry="1" width="45" height="3" />
        <rect x="55" y="36" rx="1" ry="1" width="80" height="3" />
        <rect x="145" y="36" rx="1" ry="1" width="30" height="3" />
        <rect x="185" y="36" rx="1" ry="1" width="75" height="3" />
        <rect x="270" y="36" rx="1" ry="1" width="20" height="3" />

        <rect x="2" y="42" rx="1" ry="1" width="45" height="3" />
        <rect x="55" y="42" rx="1" ry="1" width="80" height="3" />
        <rect x="145" y="42" rx="1" ry="1" width="30" height="3" />
        <rect x="185" y="42" rx="1" ry="1" width="75" height="3" />
        <rect x="270" y="42" rx="1" ry="1" width="20" height="3" />

        <rect x="2" y="49" rx="1" ry="1" width="45" height="3" />
        <rect x="55" y="49" rx="1" ry="1" width="80" height="3" />
        <rect x="145" y="49" rx="1" ry="1" width="30" height="3" />
        <rect x="185" y="49" rx="1" ry="1" width="75" height="3" />
        <rect x="270" y="49" rx="1" ry="1" width="20" height="3" />

        <rect x="2" y="56" rx="1" ry="1" width="45" height="3" />
        <rect x="55" y="56" rx="1" ry="1" width="80" height="3" />
        <rect x="145" y="56" rx="1" ry="1" width="30" height="3" />
        <rect x="185" y="56" rx="1" ry="1" width="75" height="3" />
        <rect x="270" y="56" rx="1" ry="1" width="20" height="3" />

        <rect x="2" y="63" rx="1" ry="1" width="45" height="3" />
        <rect x="55" y="63" rx="1" ry="1" width="80" height="3" />
        <rect x="145" y="63" rx="1" ry="1" width="30" height="3" />
        <rect x="185" y="63" rx="1" ry="1" width="75" height="3" />
        <rect x="270" y="63" rx="1" ry="1" width="20" height="3" />

        <rect x="2" y="70" rx="1" ry="1" width="45" height="3" />
        <rect x="55" y="70" rx="1" ry="1" width="80" height="3" />
        <rect x="145" y="70" rx="1" ry="1" width="30" height="3" />
        <rect x="185" y="70" rx="1" ry="1" width="75" height="3" />
        <rect x="270" y="70" rx="1" ry="1" width="20" height="3" />

    </vue-content-loading>
</template>
